/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Huu Khang Nguyen
 * Created: 02/02/22
 */

const defaultTableParams = {
    page: 0,
    pageSize: 10,
    orderByColumn: 'createdAt',
    orderByOrientation: 'DESC',
};

const sortedOrientation = [
    { key: 'ASC', value: 'Ascending' },
    { key: 'DESC', value: 'Descending' },
];

const supervisingSortedOrientation = [
    { key: 'ASC', value: 'A-Z' },
    { key: 'DESC', value: 'Z-A' },
];

const mapOrderToValue: Record<string, string> = {
    'A-Z': 'ASC',
    'Z-A': 'DESC',
};

export { sortedOrientation, defaultTableParams, supervisingSortedOrientation, mapOrderToValue };
